/* eslint-disable react/style-prop-object */
import { Modal } from "react-bootstrap";
import Popup from "../../Helpers/Popup/Popup";
import PopupTitle from "../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../Helpers/CloseBtn/Close";
import ViewTeam from "./ViewTeam/ViewTeam";
import { useGetSpecificTeamQuery } from "../../../Redux/service/Teams/Teams";
import { ConfigProvider, Tag } from "antd";
import Button from "../../Helpers/Button/Button";
import { useContext } from "react";
import { popupcontext } from "../../../context/Popupscontext";
import Loader from "../../Helpers/Loader/Loader";
import trans from "../../../utils";
import usePermission from "../../../hooks/usePermission";

export function TeamPopup({ teamId, onClose }) {
  const { data, isFetching } = useGetSpecificTeamQuery(teamId, {
    skip: !teamId,
    refetchOnMountOrArgChange: true,
  });
  const { handleShow } = useContext(popupcontext);

  const { edit: canEdit } = usePermission("SNAG");
  const team = data?.data || "";

  const statusColors = {
    ACTIVE: `green`,
    INACTIVE: `red`,
  };

  const onEdit = () => {
    onClose();
    handleShow("editForm", "team", teamId);
  };

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#0f6936",
          activeBg: "#0f6936",
          activeBorderColor: "#2e9245",
        },
      }}
    >
      <Popup show={!!teamId} size={"xl"}>
        <Modal.Header className="modal-header flex-between">
          <Modal.Title id="contained-modal-title-vcenter">
            <PopupTitle
              headtitle={
                <div>
                  {team.name || "Loading..."}{" "}
                  {!isFetching && team.status && (
                    <Tag
                      color={
                        statusColors[team.status] || statusColors.INACTIVE
                      }
                      className="text-capitalize"
                    >
                      {trans(team.status)}
                    </Tag>
                  )}
                </div>
              }
              subtitle={`${team.code || ""}`}
            />
          </Modal.Title>
          <Close style="close-32 close" close={onClose} img="Close" />
        </Modal.Header>
        <Modal.Body className="modal-body-scrollable fixed-popup-height">
          {isFetching ? (
            <div className="loader-container">
              <Loader />
            </div>
          ) : (
            <ViewTeam data={team} />
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="popups-footer gap-8">
            {canEdit && (
              <Button
                type="primary"
                text={trans("Edit Team")}
                htmlType="submit"
                onClick={() => onEdit()}
              />
            )}
          </div>
        </Modal.Footer>
      </Popup>
    </ConfigProvider>
  );
}
